<script>
	import { Modal, ModalHeader, ModalBody, ModalFooter } from "sveltestrap";
	import ErrorMessageHandler from "../ErrorMessageHandler/ErrorMessageHandler.svelte";
	import CustomButton from "../CustomButton/CustomButton.svelte";
	import CustomSearch from "../CustomSearch/CustomSearch.svelte";
	import { loading } from "src/store/store";

	export let open = false;
	export let toggle;
	export let err;
	export let header;
	export let bodyText;
	export let buttonText;
	export let handleSubmit;
	export let buttonColor = "danger";
	export let outline = true;
	export let extraText;
	export let enableEnter = false;
	export let close;

	export let showDropdown = false;
	export let dropdownOptions = [];
	export let dropdownPlaceholder = "Select a reason for rejection";
	export let dropdownErrorText = "Please select a reason";
	let selectedDropdown = null;
	let dropdownTouched = false;

	let load;
	loading.subscribe((value) => {
		load = value;
	});

	import { onMount } from "svelte";

	function handleKeyDown(event) {
		if (open && event.key === "Enter") {
			handleSubmit();
		}
	}

	// handle submit for both dropdown and non-dropdown modals
	function handleSubmitWrapper() {
		if (showDropdown) {
			dropdownTouched = true;
			if (!selectedDropdown) return;
			handleSubmit(selectedDropdown.value);
		} else {
			handleSubmit();
		}
	}

	onMount(() => {
		document.addEventListener("keydown", handleKeyDown);
		return () => {
			document.removeEventListener("keydown", handleKeyDown);
		};
	});
</script>

<Modal isOpen={open} backdrop centered {toggle}>
	<ModalHeader {toggle}>
		<b>
			{header}
		</b>
	</ModalHeader>
	<ModalBody>
		<ErrorMessageHandler message={err} />
		<div>
			<span>{bodyText}</span>
		</div>
		{#if extraText}
			<br />
			<div>
				<span>{extraText}</span>
			</div>
		{/if}
		{#if showDropdown}
			<div style="margin-top: 24px;">
				<label
					class="mb-1"
					style="font-weight: 500;"
					for="reject-reason"
				>
					Reason<span style="color: #B3261E;">*</span>
				</label>
				<CustomSearch
					items={dropdownOptions}
					bind:value={selectedDropdown}
					placeholder={dropdownPlaceholder}
					error={dropdownTouched && !selectedDropdown}
					errorText={dropdownErrorText}
					isSearchable={false}
				/>
			</div>
		{/if}
	</ModalBody>
	<ModalFooter>
		<CustomButton buttonText="Cancel" onClick={toggle} />
		<CustomButton
			{buttonText}
			onClick={handleSubmitWrapper}
			color={buttonColor}
			{outline}
			{load}
			disabled={showDropdown ? !selectedDropdown : false}
			keydown={true}
		/>
	</ModalFooter>
</Modal>
